import moment from "moment";
import { List } from "immutable";

import { EMPTY_LIST } from "app/app.constants";
import { WORK_SCHEDULE_REPORT_TYPE } from "features/planner/report/report.constants";

export const getWorkScheduleReportStartDate = (reportType, date) => {
  switch (reportType) {
    case WORK_SCHEDULE_REPORT_TYPE.MONTH:
      return date.startOf("month").subtract(7, "days");
    case WORK_SCHEDULE_REPORT_TYPE.YEAR:
      return date
        .startOf("year")
        .subtract(7, "weeks")
        .startOf("week");
    default:
      break;
  }
};

export const getWorkScheduleReportEndDate = (reportType, date) => {
  switch (reportType) {
    case WORK_SCHEDULE_REPORT_TYPE.MONTH:
      return date.endOf("month").add(7, "days");
    case WORK_SCHEDULE_REPORT_TYPE.YEAR:
      return date
        .endOf("year")
        .add(7, "weeks")
        .endOf("week");
    default:
      break;
  }
};

export const generateWorkScheduleReportDates = report => {
  const startDate = report.getIn(["parameters", "startDate"]);
  const endDate = report.getIn(["parameters", "endDate"]);
  const type = report.getIn(["parameters", "reportType"]);

  switch (type) {
    case WORK_SCHEDULE_REPORT_TYPE.MONTH:
      return List(moment.range(startDate, endDate).by("day"));
    case WORK_SCHEDULE_REPORT_TYPE.YEAR:
      return List(moment.range(startDate, endDate).by("week")).map(date =>
        date.startOf("isoWeek"),
      );

    default:
      return EMPTY_LIST;
  }
};
